import { ButtonSearch } from '@/components/common/Button';
import Combobox from '@/components/common/Combobox';
import { Form, FormControl, FormField, FormItem } from '@/components/common/Form';
import { Input } from '@/components/common/Input';
import { BIKE_STATUS_CONFIG } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { isPathEk } from '@/utils/routes';
import { observer } from 'mobx-react-lite';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface FilterProps {
    form: UseFormReturn<any>,
    isInModal?: boolean,
    onSearch: (searchParams?: any) => void
}

export default observer(function FilterForm({ form, isInModal = false, onSearch }: FilterProps) {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        authStore: { profileEk, profileGas },
        bikeStore: { bikeModelList }
    } = useStore();

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSearch)}>
                <div className='layout-filter max-h-[75vh] overflow-y-auto'>
                    <Input className='' disabled value={isEk ? profileEk?.fullname : profileGas?.fullname} />
                    <FormField
                        control={form.control}
                        name='vehicleStatus'
                        render={({ field }) => (
                            <FormItem>
                                <Combobox
                                    placeholder={t('placeholder.bike_status')}
                                    value={field.value?.toString() ?? ''}
                                    onChange={(item) => {
                                        field.onChange(item?.code ?? '');
                                    }}
                                    search={false}
                                    items={
                                        Object.values(BIKE_STATUS_CONFIG).map((item) => {
                                            return {
                                                label: t(`words_title.${item.key}`) ?? '',
                                                value: item.value.toString(),
                                                code: item.value
                                            };
                                        })
                                    }
                                />
                            </FormItem>
                        )}
                    />
                    {!isInModal && (
                        <FormField
                            control={form.control}
                            name='bikeModel'
                            render={({ field }) => (
                                <FormItem>
                                    <FormControl>
                                        <Combobox
                                            placeholder={t('field.model_name')}
                                            value={field.value}
                                            onChange={(item) => {
                                                field.onChange(item?.value ?? '');
                                            }}
                                            search={true}
                                            items={
                                                (Array.isArray(bikeModelList) && bikeModelList?.length > 0 ?
                                                    [
                                                        ...bikeModelList.map(item => ({
                                                            label: item.bikeModel,
                                                            value: item.bikeModel,
                                                            code: item.bikeModel
                                                        }))
                                                    ] :
                                                    []
                                                )
                                            }
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />
                    )}

                    <div className='col-span-full flex justify-center'>
                        <ButtonSearch size='md' className='max-w-52'>
                            {t('button.search')}
                        </ButtonSearch>
                    </div>

                </div>
            </form>
        </Form>
    );
});
